import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AUTH_FACEBOOK_PROVIDER,
  AUTH_GOOGLE_PROVIDER,
  socialLogin,
} from "../../app/firestore/firebaseService";
import googleLogo from "../../assets/icons/google-social-logo.svg";
import facebookLogo from "../../assets/icons/facebook-icon-social.svg";
import { closeModal } from "../../app/common/modals/modalReducer";
import { useHistory } from "react-router-dom";

export default function SocialLogin({
  provider = AUTH_GOOGLE_PROVIDER,
  buttonText,
  margin = 0,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { responsive } = useSelector((state) => state.app);

  async function handleSocialLogin() {
    dispatch(closeModal());
    await socialLogin(dispatch, history, provider, responsive.isMobile).then(
      () => console.log("social login")
    );
  }

  function getLogo() {
    if (provider === AUTH_GOOGLE_PROVIDER) {
      return googleLogo;
    } else if (provider === AUTH_FACEBOOK_PROVIDER) {
      return facebookLogo;
    }
  }

  const icon = getLogo();

  return (
    <button
      type="button"
      className="social-login-button"
      onClick={() => handleSocialLogin()}
      style={{ margin: margin }}
    >
      <img
        className="social-login-logo"
        src={icon}
        alt={`${provider} logo`}
        data-testid="logo-image-testid"
      />
      <span className="social-login-google-text">
        {buttonText || "Sign in with Google"}
      </span>
    </button>
  );
}
